module.exports = __webpack_public_path__ + "471d733ad436f655210fcb2a9e7d356a.svg";